import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'attivita-collettive',
  titolo: 'Attività collettive',
  gruppo: 'Il lavoro con le persone',
  permesso: 'attivita_collettiva.leggi',
  aCheServe: 'Corsi, laboratori ed eventi organizzati da CIDIS: dove, quando, con quali partner e quanti '
    + 'partecipanti. L’iscrizione di una persona si scrive nel suo intervento, non qui.',
  parti: [
    {
      titolo: 'L’elenco',
      testo: [
        'La voce «Attività collettive» mostra titolo e tipologia, periodo, comune e sede che organizza, ore, '
          + 'partecipanti, progetto e partner.',
      ],
      immagine: {
        file: 'attivita-collettive.webp', larghezza: 1200, altezza: 800,
        descrizione: 'L’elenco delle attività collettive con periodo, luogo, partecipanti e progetto.',
      },
    },
    {
      titolo: 'Registrare un’attività',
      permesso: 'attivita_collettiva.gestisci',
      passi: [
        'Premi «Nuova attività». Scrivi «Titolo», «Tipologia», «Inizio», «Fine» e «Ore totali».',
        'In «Dove e con chi» scegli la «Sede che organizza», il «Comune in cui si svolge» (anche diverso da '
          + 'quello della sede) e il «Progetto», oppure «nessun progetto».',
        'In «Partner» cerca l’ente per nome o sigla e premi «Aggiungi il partner». Ripeti per ogni ente.',
        'In «Partecipanti» scrivi uomini, donne e minori: il totale si calcola da solo. Se non conosci la '
          + 'suddivisione, scrivi solo il totale.',
        'Premi «Crea».',
      ],
      nota: 'Per correggere usa «Modifica» nella riga: la tipologia non si cambia.',
    },
  ],
  avvertenze: [
    {
      quando: 'L’ente partner non compare fra i suggerimenti.',
      cosaFare: 'Si scelgono solo enti registrati: chiedi a chi gestisce gli enti di inserirlo da «Enti», o '
        + 'inseriscilo tu se puoi.',
    },
    {
      quando: 'Un’attività vecchia ha nelle note dei «Posti».',
      cosaFare: 'Prima del 23/10/2026 si indicava la capienza: scrivi i partecipanti veri con «Modifica».',
    },
  ],
  vediAnche: ['enti', 'progetti'],
  parole: ['corso', 'laboratorio', 'evento', 'partecipanti', 'gruppo', 'partner'],
}

export default capitolo
